export default __webpack_public_path__ + "static/image1-4e7c39223cd64a2d877d4f5d6c7acca1.jpeg";